export enum SuiWalletFeatures {
  Connect = 'standard:connect',
  Disconnect = 'standard:disconnect',
  Events = 'standard:events',
  SignPersonalMessage = 'sui:signPersonalMessage',
  SignMessage = 'sui:signMessage',
  SignTransaction = 'sui:signTransaction',
  SignTransactionBlock = 'sui:signTransactionBlock',
  SignAndExecuteTransaction = 'sui:signAndExecuteTransaction',
  SignAndExecuteTransactionBlock = 'sui:signAndExecuteTransactionBlock',
}

export type SuiWalletAccount = {
  address: string;
  publicKey: string;
  chains: string[];
  features: string[];
};

export type SuiWalletFeatureDef = {
  // feature名字
  feature: string;
  // feature 上调用的方法
  method?: string;
  // feature 版本，未来可添加校验功能
  version?: string;
};
